import { render } from "./ReviewerSideNav.vue?vue&type=template&id=59eb5964"
import script from "./ReviewerSideNav.vue?vue&type=script&lang=js"
export * from "./ReviewerSideNav.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__